"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popoverPlacements = exports.default = void 0;
const tslib_1 = require("tslib");
// eslint-disable-next-line no-duplicate-imports,import/no-default-export
var Popover_1 = require("./Popover");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return Popover_1.Popover; } });
tslib_1.__exportStar(require("./theme"), exports);
// eslint-disable-next-line no-duplicate-imports
var placements_1 = require("./placements");
Object.defineProperty(exports, "popoverPlacements", { enumerable: true, get: function () { return placements_1.popoverPlacements; } });
//# sourceMappingURL=index.js.map